import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Scan } from './pages/Scan';
import { Thuisbatterij } from './pages/Thuisbatterij';
import { OverOns } from './pages/OverOns';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fbjbj4ny1vvy">
      <Routes data-id="element-1" data-mp="3fb173kr4obcy">
        <Route path="/" element={<Home data-id="element-3" data-mp="2rkx4ngpoehnj" />} data-id="element-2" data-mp="3fb9mpkemxuru" />
        <Route path="/scan" element={<Scan data-id="element-5" data-mp="2rlp1euv0elfe" />} data-id="element-4" data-mp="2rkdxmv1kddoa" />
        <Route path="/thuisbatterij" element={<Thuisbatterij data-id="element-7" data-mp="2mm2lgdnsqr2w" />} data-id="element-6" data-mp="2rl6th0yziirn" />
        <Route path="/over-ons" element={<OverOns data-id="element-9" data-mp="2mnngs5hxqe1t" />} data-id="element-8" data-mp="2mmvlyww5wkcl" />
        <Route path="/contact" element={<Contact data-id="element-11" data-mp="31ayr642drs0c" />} data-id="element-10" data-mp="31aqeac69cmp5" />
        <Route path="*" element={<Home data-id="element-13" data-mp="31cte1nx7pu72" />} data-id="element-12" data-mp="31bia9o3romfy" />
      </Routes>
    </BrowserRouter>;
}